import styles from './cancel-registration-dialog.module.scss';
import { useContext, useState } from 'react';
import { makeCourseRequest, useCourseGetRequestHook } from '../../../requestUtils';
import { CheckboxLabel, Dialog, DialogActions, DialogContent, DialogTitle, GrayOutlinedButton, LoadingButton, SnackBarContext, Typography } from '@frontend-workspace/react-shared-lib';
import { IRegistration } from '../../../_models/registration';
import { useTranslation } from 'react-i18next';

/* eslint-disable-next-line */
export interface CancelRegistrationDialogProps {
  onClose: () => void,
  open: boolean,
  courseId: string,
  refreshData: () => void
}

export function CancelRegistrationDialog(props: CancelRegistrationDialogProps) {
  const { data: registration }: { data: IRegistration } = useCourseGetRequestHook(`course/registration/${props.courseId}`, undefined);

  const { t } = useTranslation();
  const { setSnackbarMessage } = useContext(SnackBarContext);
  const [loading, setLoading] = useState<boolean>(false);
  const [sendEmail, setSendEmail] = useState<boolean>(false);

  const fullName = () => {
    return registration?.person?.firstName + ' ' + registration?.person?.lastName
  };

  const handleCancelRegistration = () => {
    setLoading(true);
    const body = {
      id: registration.id,
      person: registration.person,
      course: registration.course,
      canceled: true,
      comments: registration.comments,
      invoiceInfo: registration.invoiceInfo,
      registeredBy: registration.registeredBy,
      company: registration.company,
      sendEmail: sendEmail,
      hasAnsweredSurvey: registration.hasAnsweredSurvey,
      hasSentCertificate: registration.hasSentCertificate
    }
    makeCourseRequest(`course/deRegister`, 'POST', body).then(result => {
      setSnackbarMessage({ content: t('cancelRegistration.canceledCourseParticipant'), type: "success" });
      setLoading(false);
      props.onClose();
      props.refreshData();
    }).catch(() => setSnackbarMessage({ content: t('cancelRegistration.couldNotCancelCourseParticipant'), type: "error" }));
  };

  return (
    <Dialog
      open={props.open}
      maxWidth="sm"
      fullWidth>
      <DialogTitle className='mb-4'>
        {t('cancelRegistration.areYouSureYouWantToCancelYourRegistration')}
      </DialogTitle>
      <DialogContent>
        <Typography
          component="div"
          variant='subtitle3'
          className='mb-2'>
          {fullName()}
        </Typography>
        <Typography
          component="div"
          variant='subtitle3'
          className='mb-3'>
          {registration?.person?.email}
        </Typography>
        <div className='d-inline-flex mb-3'>
          <CheckboxLabel
            label={<span>{t('cancelRegistration.sendEmailTo')} {fullName()}</span>}
            onChange={() => setSendEmail(!sendEmail)}
          />
        </div>
      </DialogContent>
      <DialogActions>
        <LoadingButton
          variant="contained"
          size='large'
          color='error'
          onClick={handleCancelRegistration}
          disabled={loading}
          loading={loading}
          className='minButtonWidth'>
          {loading ? '' : t('cancelRegistration.cancel')}
        </LoadingButton>
        <GrayOutlinedButton
          variant="outlined"
          size='large'
          onClick={props.onClose}
          className='minButtonWidth'>
          {t('standard.cancel')}
        </GrayOutlinedButton>
      </DialogActions>
    </Dialog>
  );
}

export default CancelRegistrationDialog;
